export const _$ = (selector) => {
    return document.querySelector(selector)
}
export const _$$ = (selector) => {
    return document.querySelectorAll(selector) || []
}
export const removeClass = (selector, className) => {
    if(selector.length == 1) {
        selector.classList.remove(className)
    } else {
        selector.forEach((el) => {
            el.classList.remove(className)
        })
    }
}
